export const REGEX_CORREO_ESQUEMA_MH =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]([a-z0-9-]*[a-z0-9])?$/i

export const LARGO_MAXIMO_CORREO = 100

export const SEPARADOR_CORREOS = ','

export const separarCorreos = (valor: any): Array<string> =>
  `${valor ?? ''}`
    .split(SEPARADOR_CORREOS)
    .map((parte: string) => parte.trim())
    .filter((parte: string) => parte !== '')

export const listaDeCorreos = (valor: any, chips?: Array<string> | null): Array<string> => {
  const deChips = (Array.isArray(chips) ? chips : []).flatMap((chip: any) => separarCorreos(chip))
  return [...deChips, ...separarCorreos(valor)]
}

export const correoEsValido = (valor: any): boolean => {
  const correo = `${valor ?? ''}`.trim()
  if (correo === '') return false
  if (correo.length > LARGO_MAXIMO_CORREO) return false
  return REGEX_CORREO_ESQUEMA_MH.test(correo)
}

export const motivoCorreoInvalido = (valor: any): string => {
  const correo = `${valor ?? ''}`.trim()
  if (correo === '') return ''
  if (correoEsValido(correo)) return ''

  if (correo.length > LARGO_MAXIMO_CORREO)
    return `El correo «${correo.slice(0, 40)}…» tiene ${
      correo.length
    } caracteres y el Ministerio de Hacienda acepta un máximo de ${LARGO_MAXIMO_CORREO}. Acórtelo o use otra dirección.`

  if (!correo.includes('@'))
    return `El correo «${correo}» no lleva arroba (@). Verifique que esté escrito completo, por ejemplo nombre@empresa.com.`

  if (correo.split('@').length > 2)
    return `El correo «${correo}» lleva más de una arroba (@). Escriba una sola dirección, o sepárelas con coma.`

  if (/\s/.test(correo))
    return `El correo «${correo}» tiene espacios en blanco. Quítelos y vuelva a escribirlo.`

  const [usuario, dominio] = correo.split('@')

  if (usuario === '')
    return `El correo «${correo}» no tiene nada antes de la arroba (@). Indique el nombre del buzón, por ejemplo nombre@empresa.com.`

  if (dominio === '')
    return `El correo «${correo}» no tiene nada después de la arroba (@). Indique el dominio, por ejemplo nombre@empresa.com.`

  if (!dominio.includes('.'))
    return `El correo «${correo}» no tiene un dominio completo después de la arroba (@). Debe terminar en algo como .com o .com.sv.`

  return `El correo «${correo}» no tiene un formato válido. Escríbalo en la forma nombre@empresa.com.`
}

export const validarCorreosReceptor = (valor: any, chips?: Array<string> | null): string => {
  const correos = listaDeCorreos(valor, chips)
  if (correos.length === 0) return ''

  for (const correo of correos) {
    const motivo = motivoCorreoInvalido(correo)
    if (motivo !== '') return motivo
  }

  return ''
}

export const MENSAJE_CORREO_RECEPTOR_INVALIDO =
  'Revise el correo electrónico del cliente: el Ministerio de Hacienda rechaza el documento si la dirección no tiene formato de correo. ' +
  'Si necesita registrar varios correos, sepárelos con coma.'
